import { render, staticRenderFns } from "./glheader.vue?vue&type=template&id=a1886c8c&"
import script from "./glheader.vue?vue&type=script&lang=js&"
export * from "./glheader.vue?vue&type=script&lang=js&"
import style0 from "./glheader.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports